import { Action } from '@ngrx/store';

import { ContainerIdentifierWithIndex } from '../../state';

export enum ActionBarActionTypes {
  UPDATE_HIGHLIGHTED_ACTION_BAR = '[Action bar] Update highlighted action bar',
}

export interface HighlightActionBarPayload {
  highlighted: ContainerIdentifierWithIndex | null;
}

export class UpdateHighlightedActionBarAction implements Action {
  readonly type = ActionBarActionTypes.UPDATE_HIGHLIGHTED_ACTION_BAR;

  constructor(public payload: HighlightActionBarPayload) {}
}

export type ActionBarActions = UpdateHighlightedActionBarAction;
